import { FamilyHome } from "../FamilyHome.jsx";

function MathFamilySeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Math by feel, not by flashcard
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Most "math games" are reskinned flashcards. Drag the answer onto the
        bubble, watch confetti, repeat. They train recall and nothing else.
        NerdMath games are different in one specific way: they make you
        <em> handle the mathematical object directly.</em> You drag π onto a
        number line. You aim a parabola at a target. You set a slope by hand.
        You construct an angle with a virtual compass. The math becomes a
        thing you steer, not a fact you memorize.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Why "by feel" works
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Number sense — the unspoken intuition that 7 × 8 is somewhere near 50,
        that √2 is a bit less than 1.5, that a slope of 3 is steeper than a
        slope of 2 — is what separates students who struggle from students
        who fly. It cannot be drilled with flashcards because flashcards train
        recall of facts, not internal estimation of quantities. The way it is
        actually built is through repeated, slightly varied physical-feeling
        interactions with mathematical objects. That is exactly what each of
        these games does, deliberately, in their own corner of math.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        What each game teaches
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Number Line Drop is for the unit-vs-decimal-vs-irrational frame —
        feeling where π and e and √2 sit relative to each other. Slope
        Slider trains the rise-over-run intuition before the formula. Trajectory
        is projectile motion as game; you internalize a parabola by aiming
        one. Funcion teaches you to recognize a function family from its
        behavior, not its formula. Area Architect composes geometric shapes
        into target areas. Transform Tetris turns rotations and reflections
        into a named-move vocabulary. Estimate trains Fermi estimation — the
        ability to estimate any quantity to within 10× using nothing but
        plausible building blocks. Triangle Forge teaches the named special
        triangles. Modular teaches clock arithmetic, including primitive
        roots and orbits. Constructor is classical Euclidean construction
        with virtual compass and straightedge — the same toolkit Euclid used
        in 300 BCE, modernized as a touch UI.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Honest about what these games are
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        They are not a curriculum. They will not get you ready for the AP
        Calculus exam by themselves. They are intuition-builders, deliberately
        narrow in scope, designed to fix the gaps that a textbook leaves —
        the "what does this even mean" gap, the "I can compute it but I don't
        feel it" gap. Use them alongside whatever real math work you are doing,
        and the textbook will read easier afterward. They are also free, no
        signup required, and we do not track you individually. The collection
        grows when a game that fits this philosophy gets built; it does not
        grow on a schedule, and it does not include filler.
      </p>
    </>
  );
}

export default function MathHome() {
  return <FamilyHome familyId="math" seoContent={<MathFamilySeo />} />;
}
